import { validateCPF } from 'validations-br';
import * as Yup from 'yup';

export const forgotPasswordValidation = Yup.object({
  cpf: Yup.string().test('is-cpf', 'CPF não é válido', (value: any) =>
    validateCPF(value)
  ),
});
